<template>
    <v-container fluid class="pa-0">
    <v-row class="align-stretch justify-start">
      <v-col cols="12" md="4" class="pa-2 pt-0">
        <LastPlayersSearch class="mr-3 flex-grow-1" @heightChange="lastPlayersSearchHeight=$event" style="min-height:260px"></LastPlayersSearch>
      </v-col>
      <v-col cols="12" md="4" class="pa-2 pt-0">
        <FavoritesWidget
          :userId="currentUser.id"
          class="mr-3 flex-grow-1"
          v-bind:style="{'height':lastPlayersSearchHeight+'px'}"
        ></FavoritesWidget>
      </v-col>
      <v-col cols="12" md="4" class="pa-2">
        <CollectionsWidget
          class="flex-grow-1"
          v-bind:style="{'height':lastPlayersSearchHeight+'px'}"
        ></CollectionsWidget>
      </v-col>
      <!--Hub-->
      <v-col cols="12" md="8" class="pa-2" v-if="userHasRole('ROLE_DRIBLAB_HUB')">
        <LastScoutingAnalysesWidget></LastScoutingAnalysesWidget>
      </v-col>
      <v-col cols="12" md="4" class="pa-2" v-if="userHasRole('ROLE_DRIBLAB_HUB')">
        <ScoutingTasksWidget></ScoutingTasksWidget>
      </v-col>
      <!--Capture-->
      <v-col cols="12" md="8" class="pa-2" v-if="userHasRole('ROLE_VIDEO')">
        <UploadedGamesWidget></UploadedGamesWidget>
      </v-col>
      <v-col cols="12" md="4" class="pa-2" v-if="userHasRole('ROLE_VIDEO')">
        <CapturePlaylistsWidget></CapturePlaylistsWidget>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import FavoritesWidget from "./widgets/FavoritesWidget";
import CollectionsWidget from "./widgets/CollectionsWidget";
import LastPlayersSearch from "./widgets/LastPlayersSearch";
import LastScoutingAnalysesWidget from "./widgets/LastScoutingAnalysesWidget.vue";
import ScoutingTasksWidget from "./widgets/ScoutingTasksWidget.vue";
import { userHasRole } from "../../utils/functions";
import UploadedGamesWidget from "./widgets/UploadedGamesWidget.vue";
import CapturePlaylistsWidget from "./widgets/CapturePlaylistsWidget.vue";

export default {
  name: "BrandDashboard",
  props: {},
  components: {
    FavoritesWidget,
    CollectionsWidget,
    LastPlayersSearch,
    LastScoutingAnalysesWidget,
    ScoutingTasksWidget,
    UploadedGamesWidget,
    CapturePlaylistsWidget
  },
  data() {
    return {
      loading: false,
      lastPlayersSearchHeight: null
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    }
  },
  mounted() {
    this.loadViewData();
  },
  methods: {
    loadViewData() {},
    userHasRole(role) {
      return userHasRole(this.currentUser, role);
    },
  }
};
</script>